<template>





	<main justify="center" class="container-servicios">



		<v-container>

			<v-col class="d-flex flex-column aling-center align-items-md-start ">
				<v-text class="h6 primary--text ">Nuestros</v-text>
				<v-text class="h3   font-weight-bold">
					Servicios
				</v-text>
			</v-col>

		</v-container>
		
			<div class="card">
				<VueSlickCarousel class="ma-0 pa-0  servicios-carousel" v-bind="settings">
					
					<v-col class="ma-0 pa-0 rounded-lg" v-for="item in items" :key="item.img">
						<picture class="cover d-flex justify-sm-center " width="100%">
							<source media="(min-width: 2880px)" :srcset="item.img.xl2" />
							<source media="(min-width: 2160px)" :srcset="item.img.xl" />
							<source media="(min-width: 1888px)" :srcset="item.img.lg2" />
							<source media="(min-width: 1440px)" :srcset="item.img.lg2" />
							<source media="(min-width: 1264px)" :srcset="item.img.md2" />
							<source media="(min-width: 720px)" :srcset="item.img.md" />
							<source media="(min-width: 600px)" :srcset="item.img.xs2" />


							<img loading="lazy" :src="item.img.xs" class="responsive-img rounded-lg" />
						</picture>
					</v-col>
				



				</VueSlickCarousel>
			</div>

		

	</main>




</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'

// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
	name: 'MyComponent',
	components: { VueSlickCarousel },

	data() {
		return {
			isActive: false,
			settings: {
				"lazyLoad": "ondemand",
				"arrows": false,
				"dots": true,
				"infinite": true,
				"slidesToShow": 1,
				"slidesToScroll": 1,
				"initialSlide": 0,
				"autoplay": true,
				"speed": 1500,
				"autoplaySpeed": 4000,
				"cssEase": "ease-out",
				"responsive": [
					{
						"breakpoint": 960,
						"settings": {
							"lazyLoad": 'progressive',
							"dots": true,
							"infinite": true,
							"speed": 600,
							"cssEase": 'ease-out',
							"autoplaySpeed": 4000,
							"slidesToShow": 1,
							"slidesToScroll": 1
						}
					},
					{
						"breakpoint": 600,
						"settings": {
							"slidesToShow": 1,
							"slidesToScroll": 1,
							"initialSlide": 2
						}
					},
					{
						"breakpoint": 400,
						"settings": {
							"arrows": false,
							"touchMover": true,
							"dots": false,
							"infinite": true,
							"focusOnSelect": true,
							"slidesToShow": 1,
							"slidesToScroll": 1,
							"touchThreshold": 4,
							"speed": 500,
						}
					}
				]
			},
			items: [
				{
					img: {
						xs: "/images/servicios/boleteria_360.webp",
						xs2: "/images/servicios/boleteria_600.webp",
						sm: "/images/servicios/boleteria_720.webp",
						md: "/images/servicios/boleteria_960.webp",
						md2: "/images/servicios/boleteria_1264.webp",
						lg: "/images/servicios/boleteria_1440.webp",
						lg2: "/images/servicios/boleteria_1888.webp",
						xl: "/images/servicios/boleteria_2160.webp",
						xl2: "/images/servicios/boleteria_2880.webp",
					},
					alt: "",
					title: "boleteria",
				},
				{
					img: {
						xs: "/images/servicios/control_360.webp",
						xs2: "/images/servicios/control_600.webp",
						sm: "/images/servicios/control_720.webp",
						md: "/images/servicios/control_960.webp",
						md2: "/images/servicios/control_1264.webp",
						lg: "/images/servicios/control_1440.webp",
						lg2: "/images/servicios/control_1888.webp",
						xl: "/images/servicios/control_2160.webp",
						xl2: "/images/servicios/control_2880.webp",
					},
					alt: "",
					title: "control",
				},
				{
					img: {
						xs: "/images/servicios/credenciales_360.webp",
						xs2: "/images/servicios/credenciales_600.webp",
						sm: "/images/servicios/credenciales_720.webp",
						md: "/images/servicios/credenciales_960.webp",
						md2: "/images/servicios/credenciales_1264.webp",
						lg: "/images/servicios/credenciales_1440.webp",
						lg2: "/images/servicios/credenciales_1888.webp",
						xl: "/images/servicios/credenciales_2160.webp",
						xl2: "/images/servicios/credenciales_2880.webp",
					},
					alt: "",
					title: "credenciales",
				},
				{
					img: {
						xs: "/images/servicios/evento_360.webp",
						xs2: "/images/servicios/evento_600.webp",
						sm: "/images/servicios/evento_720.webp",
						md: "/images/servicios/evento_960.webp",
						md2: "/images/servicios/evento_1264.webp",
						lg: "/images/servicios/evento_1440.webp",
						lg2: "/images/servicios/evento_1888.webp",
						xl: "/images/servicios/evento_2160.webp",
						xl2: "/images/servicios/evento_2880.webp",
					},
					alt: "",
					title: "evento",
				},
				{
					img: {
						xs: "/images/servicios/manillas_360.webp",
						xs2: "/images/servicios/manillas_600.webp",
						sm: "/images/servicios/manillas_720.webp",
						md: "/images/servicios/manillas_960.webp",
						md2: "/images/servicios/manillas_1264.webp",
						lg: "/images/servicios/manillas_1440.webp",
						lg2: "/images/servicios/manillas_1888.webp",
						xl: "/images/servicios/manillas_2160.webp",
						xl2: "/images/servicios/manillas_2880.webp",
					},
					alt: "",
					title: "manillas",
				}
			],

		};


	},

};
</script>
<style scoped>
.container-servicios {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: min-content 1.5fr;
	gap: 0px 0px;
	grid-template-areas:
		"titulo"
		"card";
	padding: 2rem;
}

.titulo {
	grid-area: titulo;
}

.card {
	grid-area: card;
	height: 100%;
	border-radius: 16px;
}

.font {
	font-family: Montserrat;
}

.titulo_eventos {
	margin-top: 360px;
	margin-left: 16px;
}

.responsive-img {
	width: 100%;
	height: auto;
	object-fit: cover;
}




.titulo_categorias {
	position: absolute;
	bottom: 0;
	width: 100%;
	background-color: rgba(56, 56, 56, 0.2);

	margin: 0;
	padding: 10px;

	z-index: 1;

}

@media (min-width: 600px) and (max-width: 719px) {
	.responsive-img {
		height: 688px;
		width: 480px;
		display: flex;
		justify-self: center;

	}

}

@media (min-width: 1240px) {
	.responsive-img {
		height: 528px;


	}
}

@media (min-width: 1950px) {
	.responsive-img {
		height: 800px;


	}

}
</style>